import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
import Money from '../../../../../../Money';
import { CdnIcon } from '@shared/ui';
const ICON_NAME_MAP = {
    confirmed: 'Info/Item Icluded',
    unconfirmed: 'Info/Details'
};
const CardExtraSummaryItem = ({ icon, label, status, price, isLoading, onDelete }) => {
    const { CardExtraSummaryItem: theme } = useTheme('Shared').CardExtraView;
    const isRequested = status === 'requested';
    const isConfirmed = status === 'confirmed';
    const isUnconfirmed = status === 'unconfirmed';
    const statusIcon = ICON_NAME_MAP[status];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(theme.root, {
                [theme.root_requested]: isRequested,
                [theme.root_confirmed]: isConfirmed,
                [theme.root_unconfirmed]: isUnconfirmed
            }) },
            React.createElement("div", { className: theme.label },
                icon && (React.createElement("div", { className: theme.icon },
                    React.createElement(CdnIcon, { icon: icon }))),
                React.createElement("span", null, label)),
            React.createElement("div", { className: theme.info }, !!statusIcon ? (React.createElement("div", { className: theme.icon },
                React.createElement(CdnIcon, { icon: statusIcon }))) : (React.createElement(React.Fragment, null,
                price && React.createElement(Money, { money: price }),
                onDelete && !isRequested && (React.createElement("div", { className: theme.button_delete, onClick: onDelete },
                    React.createElement(CdnIcon, { icon: "Action/Close-Clear" })))))))));
};
export default CardExtraSummaryItem;
